import { CRMTable } from './Table.js';

export class CRMOrders {
	constructor(vroc) {
		this.vroc = vroc;
		this.id = 'crm-orders';
		this.tableComponent = null; // Ссылка на дочерний компонент (таблицу)

		let url = new URL(window.location.href);

		this.mode = url.searchParams.get('mode');
		this.job = url.searchParams.get('job');

		this.init();
		this.initTable();
	}

	async init() {
		await this.vroc.attachComponent({
			id: this.id,
			xmlUrl: `/ajax.php?mid=47&action=loadOrders&mode=${this.mode ?? ''}&job=${this.job ?? ''}`,
			templateId: 'mod_crm/orders',
			node: '.orders'
		});

		this._bindEvents();
	}

	initTable() {
		// Создаём и инициализируем таблицу сразу
		this.tableComponent = new CRMTable(this.vroc, this.mode, this.job);
		this.tableComponent.init();
		window.crmTable = this.tableComponent;
	}

	_bindEvents() {
		
	}

	async changeMode(mode) {
		this.mode = mode;
		this.job = '';

		const formData = new FormData();
		formData.append('action', 'loadOrders');
		formData.append('mode', mode);

		document.querySelector('.orders .loader').classList.add('active');

		const response = await fetch('/ajax.php?mid=47', {
			method: 'POST',
			body: formData
		});

		const xmlText = await response.text();
		this.vroc.updateComponent(this.id, xmlText);

		// Перезагружаем дочерний компонент (таблицу)
		this.reloadTable();
	}

	async changeJob(job) {
		this.mode = '';
		this.job = job;

		document.querySelector('.orders .loader').classList.add('active');

		const formData = new FormData();
		formData.append('action', 'loadOrders');
		formData.append('job', job);

		const response = await fetch('/ajax.php?mid=47', {
			method: 'POST',
			body: formData
		});

		const xmlText = await response.text();

		this.vroc.updateComponent(this.id, xmlText);

		// Перезагружаем дочерний компонент (таблицу)
		this.reloadTable();
	}

	async reloadTable() {
		if (this.tableComponent) {
			// Если таблица уже существует, обновляем её
			const formData = new FormData();
			formData.append('action', 'loadTable');
			formData.append('mode', this.mode ?? '');
			formData.append('job', this.job ?? '');

			document.querySelector('.orders__table-wrapper .loader').classList.add('active');

			const response = await fetch('/ajax.php?mid=47', {
				method: 'POST',
				body: formData
			});

			const xmlText = await response.text();
			this.vroc.updateComponent(this.tableComponent.id, xmlText); // Обновляем таблицу
			document.querySelector('.orders__table-wrapper .loader').classList.remove('active');
		} else {
			// Если таблицы нет, создаём её
			this.tableComponent = new CRMTable(this.vroc, this.mode);
			this.tableComponent.init();
		}
	}
}